const formatArg = (arg) => {
  if (typeof arg !== 'object' || (arg instanceof Error)) {
    return String(arg)
  }

  try {
    return JSON.stringify(arg)
  } catch (e) {
    return String(arg)
  }
}

export const formatArgs = (...args) => {
  return args.map(formatArg).join(' ')
}
